
import "./toggle-button.css"
const ToggleButton = (props) => {
    return (
        <div className="text-center">
            <label class="switch-toggle-button">
                <input
                 type="checkbox" 
                 checked={props.isChecked}
                 onClick={(e) => props.ontoggle(e)} />
                <span class="slider-toggle-button round-toggle-button"></span>
            </label>
        </div>
    )
}
export default ToggleButton